export default __webpack_public_path__ + "media/be0febbf427e65609d715fae91c41bbb86fdd46b653018a9b0513dc0016b81d1.svg";